import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import type { EnhancedAppointment } from '@bb/domain/dist/types';

const ACTION_REQUIRED_STATUSES = [
  'new',
  'time_change',
  'attempted',
  'time_passed',
];

const useViewDashAppointment = () => {
  const history = useHistory();

  const viewDashAppointment = useCallback(
    (
      appointment: Partial<EnhancedAppointment>,
      search?: Record<string, string | string[]>,
    ) => {
      let status = 'action';
      if (
        appointment.isPending &&
        !ACTION_REQUIRED_STATUSES.includes(appointment.status || '')
      ) {
        status = appointment.status || 'action';
      }
      const params = new URLSearchParams();
      if (search) {
        Object.entries(search).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
          } else {
            params.append(key, value);
          }
        });
      }
      const searchStr = params.toString();
      const path = `/appointments/${appointment.id}/${status}`;
      history.push(searchStr ? `${path}?${searchStr}` : path);
    },
    [history],
  );

  return viewDashAppointment;
};

export default useViewDashAppointment;
